import styled from "@emotion/styled";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { type InvoicesResponse } from "@skilitics/billing-api-client/definition";
import { FONT_WEIGHT_MEDIUM, PAGE_SIDE_PADDING } from "@skilitics/designer-ui-components";
import { useFormatMessage } from "@skilitics/localization";

import { api } from "#api";

import { InvoicesTable } from "./InvoicesTable";

export const InvoicesSection = () => {
  const invoices = useInvoices();
  const formatMessage = useFormatMessage(formatStrings);
  return (
    <SectionWrapper>
      <SectionHeader>
        <h3>{formatMessage("header")}</h3>
        <p>{formatMessage("subHeader")}</p>
      </SectionHeader>
      <InvoicesTable invoices={invoices.data?.items ?? []} isLoading={invoices.isFetching} />
    </SectionWrapper>
  );
};

const useInvoices = (): UseQueryResult<InvoicesResponse> => {
  return useQuery({
    queryKey: ["billing/invoices"],
    queryFn: () => api.post("/stripe/invoices", undefined),
  });
};

const SectionWrapper = styled.div`
  background: ${({ theme }) => theme.surface};
  border-radius: 8px;
`;

const SectionHeader = styled.div`
  padding: 20px ${PAGE_SIDE_PADDING / 2}px;
  h3 {
    margin: 0 0 10px;
    font-weight: ${FONT_WEIGHT_MEDIUM};
    font-size: 20px;
  }
  p {
    margin: 0;
    color: ${({ theme }) => theme.generalTextIconVariant};
    font-size: 14px;
  }
`;

const formatStrings = {
  header: {
    en: "Invoices",
  },
  subHeader: {
    en: "All invoices past and present can be found and downloaded from the list below.",
  },
};
